// extracted by mini-css-extract-plugin
module.exports = {"resetPasswordPage":"ResetPassword_resetPasswordPage__3ANgf","resetPassword":"ResetPassword_resetPassword__1fY86"};